import { MODULES, ACTIONS } from "utils/permissions"

export const ROUTE_PERMISSIONS = {
  CALENDAR: {
    module: MODULES.CALENDAR
  },
  BOOKINGS: {
    module: MODULES.BOOKINGS
  },
  BOOKINGS_VIEW: {
    module: MODULES.BOOKINGS,
    action: ACTIONS.VIEW
  },
  BOOKINGS_CREATE: {
    module: MODULES.BOOKINGS,
    action: ACTIONS.CREATE
  },
  BOOKINGS_EDIT: {
    module: MODULES.BOOKINGS,
    action: ACTIONS.EDIT
  },
  CLIENTS: {
    module: MODULES.CLIENTS
  },
  CLIENTS_VIEW: {
    module: MODULES.CLIENTS,
    action: ACTIONS.VIEW
  },
  CLIENTS_CREATE: {
    module: MODULES.CLIENTS,
    action: ACTIONS.CREATE
  },
  CLIENTS_EDIT: {
    module: MODULES.CLIENTS,
    action: ACTIONS.EDIT
  },
  CLIENTS_IMPORT: {
    module: MODULES.CLIENTS,
    action: ACTIONS.IMPORT
  },
  MESSAGES: {
    module: MODULES.MESSAGES
  },
  GALLERY: {
    module: MODULES.GALLERY
  },
  MARKETING: {
    module: MODULES.MARKETING
  },
  MARKETING_CREATE_CAMPAIGNS: {
    module: MODULES.MARKETING,
    action: ACTIONS.CREATE
  },
  MARKETING_EDIT_CAMPAIGNS: {
    module: MODULES.MARKETING,
    action: ACTIONS.EDIT
  },
  ACCOUNTING: {
    module: MODULES.ACCOUNTING
  },
  CREW: {
    module: MODULES.CREW
  },
  CREW_VIEW: {
    module: MODULES.CREW,
    action: ACTIONS.VIEW
  },
  CREW_CREATE: {
    module: MODULES.CREW,
    action: ACTIONS.CREATE
  },
  CREW_EDIT: {
    module: MODULES.CREW,
    action: ACTIONS.EDIT
  },
  EQUIPMENT: {
    module: MODULES.EQUIPMENT
  },
  EQUIPMENT_VIEW: {
    module: MODULES.EQUIPMENT,
    action: ACTIONS.VIEW
  },
  EQUIPMENT_CREATE: {
    module: MODULES.EQUIPMENT,
    action: ACTIONS.CREATE
  },
  EQUIPMENT_EDIT: {
    module: MODULES.EQUIPMENT,
    action: ACTIONS.EDIT
  },
  EQUIPMENT_DISABLE: {
    module: MODULES.EQUIPMENT,
    action: ACTIONS.DISABLE
  },
  EXPERIENCES: {
    module: MODULES.EXPERIENCES
  },
  EXPERIENCES_VIEW: {
    module: MODULES.EXPERIENCES,
    action: ACTIONS.VIEW
  },
  EXPERIENCES_CREATE: {
    module: MODULES.EXPERIENCES,
    action: ACTIONS.CREATE
  },
  EXPERIENCES_EDIT: {
    module: MODULES.EXPERIENCES,
    action: ACTIONS.EDIT
  },
  EXPERIENCES_DEACTIVATE: {
    module: MODULES.EXPERIENCES,
    action: ACTIONS.DEACTIVATE
  },
  RENTALS: {
    module: MODULES.RENTALS
  },
  RENTALS_VIEW: {
    module: MODULES.RENTALS,
    action: ACTIONS.VIEW
  },
  RENTALS_CREATE: {
    module: MODULES.RENTALS,
    action: ACTIONS.CREATE
  },
  RENTALS_EDIT: {
    module: MODULES.RENTALS,
    action: ACTIONS.EDIT
  },
  RENTALS_DEACTIVATE: {
    module: MODULES.RENTALS,
    action: ACTIONS.DEACTIVATE
  },
  SETTINGS: {
    module: MODULES.SETTINGS
  }
}
